"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _StencilContext = require("./StencilContext");
var _propTypes = require("./propTypes");
const dummy = () => null;
const DescribedStencilProviderWithDocs = (0, _stencilReactDesc.describe)(dummy).description('Parent provider for Stencil Components.');
DescribedStencilProviderWithDocs.propTypes = {
  ..._propTypes.providerPropTypes
};
DescribedStencilProviderWithDocs.defaultProps = {
  ..._StencilContext.stencilProviderDefaultProps
};
DescribedStencilProviderWithDocs.displayName = 'DescribedStencilProvider';
var _default = exports.default = DescribedStencilProviderWithDocs;